module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [(_vm.$store.getters.login_type != 'distributor') ? _c('el-tab-pane', {
    attrs: {
      "label": "图文消息",
      "name": "imagetext"
    }
  }, [_c('div', {
    staticClass: "tip-info"
  }, [_c('p', [_vm._v("当前图文已存储数量为" + _vm._s(_vm.$store.getters.login_type)), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.stats.news_count) + "篇")])]), _vm._v(" "), _c('p', [_vm._v("当前图文剩余储"), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.stats.news_limit) + "篇")])])]), _vm._v(" "), _c('news-list', {
    attrs: {
      "active-name": _vm.activeName,
      "get-status": _vm.newsStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.login_type != 'distributor') ? _c('el-tab-pane', {
    attrs: {
      "label": "微信图片",
      "name": "picture"
    }
  }, [_c('div', {
    staticClass: "tip-info"
  }, [_c('p', [_vm._v("当前微信图片已存储数量为"), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.stats.image_count) + "张")])]), _vm._v(" "), _c('p', [_vm._v("当前微信图片剩余储"), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.stats.image_limit) + "张")])])]), _vm._v(" "), _c('images-list', {
    attrs: {
      "active-name": _vm.activeName,
      "get-status": _vm.picStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "本地图片",
      "name": "qiniu"
    }
  }, [_c('localimages-list', {
    attrs: {
      "active-name": _vm.activeName,
      "get-status": _vm.localpicStatus
    }
  })], 1), _vm._v(" "), (_vm.$store.getters.login_type != 'distributor') ? _c('el-tab-pane', {
    attrs: {
      "label": "微信视频",
      "name": "video"
    }
  }, [_c('div', {
    staticClass: "tip-info"
  }, [_c('p', [_vm._v("当前视频已存储数量为"), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.stats.video_count) + "个")])]), _vm._v(" "), _c('p', [_vm._v("当前视频剩余储"), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.stats.video_limit) + "个")])])]), _vm._v(" "), _c('video-list', {
    attrs: {
      "active-name": _vm.activeName,
      "get-status": _vm.videoStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "本地视频",
      "name": "localvideo"
    }
  }, [_c('localvideos-list', {
    attrs: {
      "active-name": _vm.activeName,
      "get-status": _vm.localvideoStatus
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-568c3e6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-568c3e6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/aterialmanagement.vue
// module id = 2728
// module chunks = 0